import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { CatalogAgentClient, catalogAgentApiRef } from './api';
import { releaseHistoryRouteRef, rootRouteRef } from './routes';

export const catalogAgentPlugin = createPlugin({
  id: 'catalog-agent',
  apis: [
    createApiFactory({
      api: catalogAgentApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: deps => new CatalogAgentClient(deps),
    }),
  ],
  routes: {
    root: rootRouteRef,
    releaseHistory: releaseHistoryRouteRef,
  },
});

/** The Versions area: Matrix, Deployments and Lead time. */
export const VersionsPage = catalogAgentPlugin.provide(
  createRoutableExtension({
    name: 'VersionsPage',
    component: () =>
      import('./components/VersionsPage').then(m => m.VersionsPage),
    mountPoint: rootRouteRef,
  }),
);

export const EntityClusterPlatformCard = catalogAgentPlugin.provide(
  createComponentExtension({
    name: 'EntityClusterPlatformCard',
    component: {
      lazy: () =>
        import('./components/cluster').then(m => m.ClusterPlatformCard),
    },
  }),
);

export const EntityClusterDeployedHereCard = catalogAgentPlugin.provide(
  createComponentExtension({
    name: 'EntityClusterDeployedHereCard',
    component: {
      lazy: () =>
        import('./components/cluster').then(m => m.ClusterDeployedHereCard),
    },
  }),
);

export const EntityClusterDriftContent = catalogAgentPlugin.provide(
  createComponentExtension({
    name: 'EntityClusterDriftContent',
    component: {
      lazy: () =>
        import('./components/cluster').then(m => m.ClusterDriftContent),
    },
  }),
);

export const EntityClusterDeploymentsContent = catalogAgentPlugin.provide(
  createComponentExtension({
    name: 'EntityClusterDeploymentsContent',
    component: {
      lazy: () =>
        import('./components/cluster').then(m => m.ClusterDeploymentsContent),
    },
  }),
);

export const EntityDeploymentVersionCard = catalogAgentPlugin.provide(
  createComponentExtension({
    name: 'EntityDeploymentVersionCard',
    component: {
      lazy: () =>
        import('./components/deployment').then(m => m.DeploymentVersionCard),
    },
  }),
);

export const EntityVersionHistoryContent = catalogAgentPlugin.provide(
  createComponentExtension({
    name: 'EntityVersionHistoryContent',
    component: {
      lazy: () =>
        import('./components/deployment').then(m => m.VersionHistoryContent),
    },
  }),
);

export const EntityDeploymentGeneratedNotice = catalogAgentPlugin.provide(
  createComponentExtension({
    name: 'EntityDeploymentGeneratedNotice',
    component: {
      lazy: () =>
        import('./components/deployment').then(m => m.GeneratedNotice),
    },
  }),
);
